@if(filters.length > 0){
    <!-- Floating Toggle Button with Animated Icon Transition -->
    <div
        class="absolute left-1 top-4 rounded-full flex items-center justify-center cursor-pointer transition-all duration-700 bg-[#0066cc] z-10 p-2 sm:flex hidden"
        [ngClass]="{'left-[322px] ' : isExpanded}"
        (click)="toggleDrawer()"
    >
        <div class="relative w-4 h-4 flex items-center justify-center">
            <!-- Funnel SVG (Visible when Collapsed) -->
            @if(!isExpanding && !isExpanded) {
                <svg class="absolute transition-all duration-700 ease-in-out opacity-100 scale-100"
                    xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 64 64">
                    <g>
                        <path d="M27 59a2 2 0 0 1-2-2V37.77L6.46 17.38A5.61 5.61 0 0 1 10.61 8h42.78a5.61 5.61 0 0 1 4.15 9.38L39 37.77V49a2 2 0 0 1-.75 1.56l-10 8A2 2 0 0 1 27 59zM10.61 12a1.61 1.61 0 0 0-1.19 2.69l19.06 21A2 2 0 0 1 29 37v15.84L35 48V37a2 2 0 0 1 .52-1.35l19.06-21A1.61 1.61 0 0 0 53.39 12z" fill="white"></path>
                    </g>
                </svg>
            }

            <!-- Chevron Left Icon (Visible when Expanded) -->
             @if(isExpanding || isExpanded) {
                <mat-icon
                    class="absolute text-white transition-all duration-500 ease-in-out opacity-100 scale-100"
                    [svgIcon]="'heroicons_outline:chevron-left'">
                </mat-icon>
             }
        </div>
    </div>

    <!-- Filter Drawer -->
    <div
        [ngClass]="{
            'w-5': !isExpanded,
            'w-96': isExpanded && !isMobile,
            'sm:w-screen':isMobile,
        }"
        class="transition-all duration-700 overflow-hidden relative bg-card sm:h-[calc(100vh_-_4.5rem)] h-full "
    >
        <div
            class="flex flex-col transition-all duration-500 invisible h-full font-semibold text-[#000000bf] text-[14px]"
            [ngClass]="{ visible: isExpanded, invisible: !isExpanded }"
        >
            <div class="flex w-full h-18 sm:pl-8 border-b sm:pr-4 px-4 text-foreground relative">
                <div class="flex items-center before:content-[''] before:block before:absolute before:h-[0.3rem] before:w-[3rem] before:bg-[#0066cc] before:bottom-0">
                    {{ 'filters.title' | transloco }}
                </div>
            </div>
            <div class="flex flex-col gap-2 sm:p-4 justify-between overflow-y-auto h-full p-2">
                <form class="flex flex-col gap-3" [formGroup]="form" (keydown)="onKeyDown($event)">
                    @for(section of filters; track section){
                        @if(section.title){
                            <div class="font-semibold">
                                {{ section.title }}
                            </div>
                        }
                        <div
                            class="flex "
                            [ngClass]="{
                                'flex-col gap-3': section.direction === 'column',
                                'flex-row gap-2': section.direction === 'row'
                            }"
                        >
                            @for(slot of section.slots; track slot.field){
                                @if(!slot.hidden) {
                                    <slot-loader
                                        [ngClass]="{
                                            'w-2/4': section.direction === 'row',
                                        }"
                                        [slot]="slot"
                                        [formGroup]="form"
                                    ></slot-loader>
                                }
                            }
                        </div>
                    }
                </form>
            </div>
            <div class="flex gap-2 w-full bg-card z-10 p-4 border-t sm:relative sticky bottom-0 ">
                <z-button 
                    zType="outline" 
                    zSize="default" 
                    zFull="true"
                    (click)="reset()"
                    class="flex-1"
                >
                    {{ 'actions.reset' | transloco }}
                </z-button>
                <z-button 
                    zType="default" 
                    zSize="default" 
                    zFull="true"
                    (click)="save()"
                    class="flex-1"
                >
                    {{ 'actions.save' | transloco }}
                </z-button>
            </div>
        </div>
    </div>
}
@else {
    <div class="h-full flex justify-center items-center">
        <span class="text-lg font-bold">{{ 'filters.no-filters' | transloco }}</span>
    </div>
}
